document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.c-footer-menu-list__btn-mobile').forEach(function (btn) {
        btn.addEventListener('click', function () {
            const targetId = this.getAttribute('data-id')
            const menuList = document.querySelector('.c-footer-menu-list__items--mobile[data-id=' + targetId + ']')

            this.classList.toggle('btn-active')
            menuList.classList.toggle('is-active')
        });
    })

    document.querySelectorAll('.js-newsletter-modal-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            toggleNewsletterModal()
        })
    })

    document.querySelectorAll('a').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            const href = btn.getAttribute('href')
            if (href?.includes('#newsletter-sub')) {
                e.preventDefault()
                toggleNewsletterModal()
            }
        })
    })

    function toggleNewsletterModal() {
        const modalScreen = document.querySelector('.js-newsletter-modal')
        const documentBody = document.body

        if (modalScreen.classList.contains('open')) {
            modalScreen.classList.remove('open')
            documentBody.classList.remove('no-scroll')
            return
        }

        if (!modalScreen.classList.contains('open')) {
            modalScreen.classList.add('open')
            documentBody.classList.add('no-scroll')
        }
    }
})